import {Component, Input, OnInit} from '@angular/core';
import {Information} from "../information";

@Component({
  selector: 'app-information-fuses',
  templateUrl: './information-fuses.component.html',
  styleUrls: ['./information-fuses.component.css']
})
export class InformationFusesComponent  {
  @Input() information: Information;


  constructor() {
    this.information = new Information();
  }


}
